import api from "./api";

export async function getAudit(dossierId: number): Promise<any | null> {
    const url = `api/audit/?dossierId=${dossierId}`;
    return await api
        .get(url)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}
